import actions from './actions';
import reducer from './reducer';

const message = {
    actions,
    reducer,
    name: 'message',
};

export default message; 